import configureStore from './store';

export const { Store, persistor } = configureStore();
